export default __webpack_public_path__ + "static/media/accept.0d323db7.svg";